import script from "./QuienessomosView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuienessomosView.vue?vue&type=script&setup=true&lang=js"

import "./QuienessomosView.vue?vue&type=style&index=0&id=0e8a8ed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8a8ed4"]])

export default __exports__